import { render, staticRenderFns } from "./faceOne.vue?vue&type=template&id=36d6d797"
import script from "./faceOne.vue?vue&type=script&lang=js"
export * from "./faceOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports